import { Link, Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { useT } from "@/i18n";
import { usePageMeta } from "@/lib/format";
import { PageHeader } from "@/components/StatCard";
import Seo from "@/components/Seo";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { ChevronLeft } from "lucide-react";

import PostsTab from "@/pages/coach/social/PostsTab";
import StoriesTab from "@/pages/coach/social/StoriesTab";
import StoryWallTab from "@/pages/coach/social/StoryWallTab";
import StoryImpactTab from "@/pages/coach/social/StoryImpactTab";
import MessagesTab from "@/pages/coach/social/MessagesTab";
import WevaChatTab from "@/pages/coach/social/WevaChatTab";
import PostSchedulerTab from "@/pages/coach/social/PostSchedulerTab";

export default function Content() {
  const { user } = useAuth();
  const t = useT();
  usePageMeta(t("soc.meta_title"));

  if (user && user.role !== "coach") return <Navigate to="/app/circles" replace />;

  return (
    <div data-testid="coach-content-page">
      <Seo title={t("soc.seo")} noindex />
      <Link to="/app/coach" className="mb-3 inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground" data-testid="content-back">
        <ChevronLeft className="h-4 w-4" /> {t("soc.back")}
      </Link>
      <PageHeader eyebrow={t("soc.eyebrow")} title={t("soc.title")} subtitle={t("soc.subtitle")} />

      <Tabs defaultValue="posts" className="mt-6">
        <TabsList className="mb-4 flex h-auto w-full flex-wrap justify-start gap-1 bg-secondary/60 p-1">
          <TabsTrigger value="posts" data-testid="soc-tab-posts">{t("soc.tab_posts")}</TabsTrigger>
          <TabsTrigger value="scheduler" data-testid="soc-tab-scheduler">{t("ps.tab_label")}</TabsTrigger>
          <TabsTrigger value="stories" data-testid="soc-tab-stories">{t("soc.tab_stories")}</TabsTrigger>
          <TabsTrigger value="wall" data-testid="soc-tab-wall">{t("soc.tab_wall")}</TabsTrigger>
          <TabsTrigger value="impact" data-testid="soc-tab-impact">{t("soc.tab_impact")}</TabsTrigger>
          <TabsTrigger value="messages" data-testid="soc-tab-messages">{t("soc.tab_messages")}</TabsTrigger>
          <TabsTrigger value="weva" data-testid="soc-tab-weva">{t("soc.tab_weva")}</TabsTrigger>
        </TabsList>
        <TabsContent value="posts"><PostsTab /></TabsContent>
        <TabsContent value="scheduler"><PostSchedulerTab /></TabsContent>
        <TabsContent value="stories"><StoriesTab /></TabsContent>
        <TabsContent value="wall"><StoryWallTab /></TabsContent>
        <TabsContent value="impact"><StoryImpactTab /></TabsContent>
        <TabsContent value="messages"><MessagesTab /></TabsContent>
        <TabsContent value="weva"><WevaChatTab /></TabsContent>
      </Tabs>
    </div>
  );
}
